import { Expose } from "class-transformer";
import { EmployeeAssessmentBase } from "domain/model/base";

export default class EmployeeAssessment extends EmployeeAssessmentBase {
  @Expose({name: "company_name"})
  companyName?: string;
};
